import styled from "styled-components";
import Space from "../../Space";
import { StyledBoxBaseProps } from "./BoxBase.types";

export const StyledBoxBase = styled(Space)<StyledBoxBaseProps>`
	${({ theme, ...props }) => {
		return {
			backgroundColor:
				theme.palette.hexFor(props.backgroundColor) || "transparent",
			borderRadius: props.borderRadius ? theme.radii[props.borderRadius] : 0,
			...(props.borderTopLeftRadius && {
				borderTopLeftRadius: theme.radii[props.borderTopLeftRadius],
			}),
			...(props.borderTopRightRadius && {
				borderTopRightRadius: theme.radii[props.borderTopRightRadius],
			}),
			...(props.borderBottomLeftRadius && {
				borderBottomLeftRadius: theme.radii[props.borderBottomLeftRadius],
			}),
			...(props.borderBottomRightRadius && {
				borderBottomRightRadius: theme.radii[props.borderBottomRightRadius],
			}),
		};
	}}
`;

/**
 * TODO. Mark Graham
 * I'm leaving the code below commented out for now. This is the code we want, but is presenting
 * TypeScript issues when using react ref. TypeScript with styled components can't determine the type
 * being passed to the styled function, and this in turn raises errors when trying to pass a ref through.
 * Needs further investigation.
 */

/*export const StyledBoxBase = styled(
	({ backgroundColor, ...props }: StyledBoxBaseProps) => <Space {...props} />
)<StyledBoxBaseProps>`
	${({ theme, ...props }) => {
		return {
			backgroundColor:
				theme.palette.hexFor(props.backgroundColor) || "transparent",
			borderRadius: props.borderRadius ? theme.radii[props.borderRadius] : 0,
			...(props.borderTopLeftRadius && {
				borderTopLeftRadius: theme.radii[props.borderTopLeftRadius],
			}),
			...(props.borderTopRightRadius && {
				borderTopRightRadius: theme.radii[props.borderTopRightRadius],
			}),
			...(props.borderBottomLeftRadius && {
				borderBottomLeftRadius: theme.radii[props.borderBottomLeftRadius],
			}),
			...(props.borderBottomRightRadius && {
				borderBottomRightRadius: theme.radii[props.borderBottomRightRadius],
			}),
		};
	}}
`;*/
